import React from "react"

function Footer(){
    return(
        <div className="footer">
            By David Ye
        </div>
    )
}

export default Footer